import { signIn, signUp, signOut, type SignInInput } from 'aws-amplify/auth'
import { applyAuthScope } from './bootstrap'

export async function logIn({ username, password }: SignInInput) {
    applyAuthScope('admin')
    await signOut()
    return signIn({
        username,
        password,
        options: {
            authFlowType: 'USER_PASSWORD_AUTH'
        }
    })
}

type SignUpParameters = {
    username: string
    password: string
}

export async function register(params: SignUpParameters) {
    const { username, password } = params

    try {
        applyAuthScope('admin')
        const user = await signUp({ username, password })
        return user
    } catch (error) {
        console.log('error signing up', error)
    }
}
